<template lang="pug">
  game-score(
      headerSize="huge",
      imageSize="small",
      map="VS",
      :teams="teams",
      :scores="scores")
      sui-grid-row(slot="header")
        sui-grid-column(:width="6")
          sui-header(
            size="huge",
            textAlign="center") {{ awayTeam ? awayTeam.name : defaults.name }}

        sui-grid-column(:width="4")
          sui-header(
            size="huge",
            textAlign="center") VS

        sui-grid-column(:width="6")
          sui-header(
            size="huge",
            textAlign="center") {{ homeTeam ? homeTeam.name : defaults.name }}
</template>

<script>
import GameScore from '@/components/game/GameScore.vue';

export default {
  name: 'MatchScore',
  components: {
    GameScore,
  },
  props: {
    scores: {
      required: true,
    },
    teams: {
      required: true,
    },
  },
  data() {
    return {
      defaults: {
        name: '--',
        logo: '/logo-placeholder.svg',
      },
    };
  },
  computed: {
    awayTeam() {
      return this.teams[0];
    },
    homeTeam() {
      return this.teams[1];
    },
  },
};
</script>
